{
  "moments": [
    {
      "moment": "Anders (Hieronder zelf schrijven)"
    },
    {
      "moment": "Jij & Ik"
    },
    {
      "moment": "Eerste kus"
    },
    {
      "moment": "Toen de sterren op één lijn stonden"
    },
    {
      "moment": "Waar het allemaal begon"
    },
    {
      "moment": "Liefde onder de sterren"
    },
    {
      "moment": "Toen we trouwden"
    },
    {
      "moment": "Een ster werd geboren die nacht"
    },
    {
      "moment": "Sterrenhemel tijdens je geboorte"
    },
    {
      "moment": "De nacht waarin jij ter wereld kwam"
    },
    {
      "moment": "Toen ik geboren ben"
    },
    {
      "moment": "Toen de vonk oversloeg"
    },
    {
      "moment": "Het moment waarop we 'ja' zeiden"
    },
    {
      "moment": "Ons huis onder de sterren"
    },
    {
      "moment": "When the stars aligned"
    },
    {
      "moment": "You & Me"
    },
    {
      "moment": "Where it happened"
    },
    {
      "moment": "Where it all began"
    },
    {
      "moment": "First date"
    },
    {
      "moment": "When we met"
    },
    {
      "moment": "When it all started"
    },
    {
      "moment": "First Kiss"
    },
    {
      "moment": "When she said yes"
    },
    {
      "moment": "When he said yes"
    },
    {
      "moment": "When I was born"
    }
  ]
}
